export default class CF7FormValidation {
    constructor() {
        this.DOM = {
            requiredField: ".wpcf7-validates-as-required",
            submitButton: ".js-form-btn-submit",
            acceptanceCheckbox: ".wpcf7-acceptance",
        };

        this.requiredFields = document.querySelectorAll(this.DOM.requiredField);
        this.submitButton = document.querySelector(this.DOM.submitButton);
        this.acceptanceChecboxes = document.querySelectorAll(this.DOM.acceptanceCheckbox);
    }

    init() {
        if (this.requiredFields !== null && this.submitButton !== null && this.acceptanceChecboxes !== null){
            this.fieldValidationEvent();
        }
    }

    fieldValidationEvent() {
        if (this.requiredFields.length > 0) {
            this.submitButton.disabled = this.validateField();

            this.requiredFields.forEach((field) => {
                field.addEventListener("blur", (ev) => {
                    this.submitButton.disabled = this.validateField();
                })
            });
        }

        if (this.acceptanceChecboxes.length > 0) {
            for (let i = 0; i < this.acceptanceChecboxes.length; i++) {
                this.acceptanceChecboxes[i].addEventListener("change", (event) => {
                    this.submitButton.disabled = this.validateField();
                });
            }
        }
    }

    validateField() {
        for (let i = 0; i < this.requiredFields.length; i++) {
            if (this.requiredFields[i].value === "" || this.requiredFields[i].value === "undefined") {
                return true;
            }
        }

        for (let i = 0; i < this.acceptanceChecboxes.length; i++) {
            if (!this.acceptanceChecboxes[i].classList.contains("optional")) {
                let check = this.acceptanceChecboxes[i].querySelector("input[type=checkbox]");

                if (!check.checked) {
                    return true;
                }
            }
        }


        return false;
    }
}
